/**
 * /invoices — legacy combined page. Now a redirect-only stub.
 *
 * The combined AR + AP "Invoices" page has been split into two
 * single-purpose surfaces:
 *   - /ar — customer invoices (Sales)
 *   - /ap — vendor bills      (Purchases)
 *
 * Old bookmarks land on /ar (the more common intent given the menu
 * label was "Invoices" under Sales). Deep links of the form
 *   /invoices?tab=payable
 * are routed to /ap.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

interface LegacyInvoicesSearch {
  tab?: string;
}

export const Route = createFileRoute("/_auth/invoices/")({
  validateSearch: (search: Record<string, unknown>): LegacyInvoicesSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
  beforeLoad: ({ search }) => {
    const tab = (search as LegacyInvoicesSearch).tab;
    if (tab === "payable" || tab === "ap") {
      throw redirect({ to: "/ap" });
    }
    throw redirect({ to: "/ar" });
  },
});
